module.exports = "<nav>\n    <mat-nav-list>\n        <ng-container *ngFor=\"let link of links\">\n            <a mat-list-item\n               routerLink=\"{{ link.href }}\"\n               routerLinkActive=\"active\"\n               *ngIf=\"(!link.adminOnly || userService.isAdmin()) && (!link.accountant || userService.isAccountant())\">\n                <mat-icon md-list-icon>{{ link.icon }}</mat-icon>\n                {{ link.title }}\n            </a>\n        </ng-container>\n    </mat-nav-list>\n</nav>"


//////////////////
// WEBPACK FOOTER
// /app/src/AppModule/NavComponent/nav.component.html
// module id = ../../../../../src/AppModule/NavComponent/nav.component.html
// module chunks = main